import { isEmpty } from "lodash";
import KnowlarityIntegration from "./KnowlarityIntegration";
import ExotelAmeyoIntegration from "./ExotelAmeyo/ExotelAmeyoIntegration";
import { CALL_PROVIDERS } from "modules/utilities/utility";
import UbonaIntegration from "./UbonaIntegration";
import AgamiIntegration from "./AgamiIntegration";

export function placeOrderData(
  case_id,
  cart,
  customerAddress,
  discounts,
  zeroValueOrder,
  billingAddress,
  omsFlag,
  selectedCountry
) {
  const line_items = Object.entries(cart).map(([id, count]) => {
    return { variant_id: id, quantity: count };
  });

  const name = !isEmpty(customerAddress?.first_name)
    ? customerAddress?.first_name + (customerAddress?.last_name || "")
    : customerAddress?.name;

  const address = {
    first_name: "",
    last_name: name,
    phone: customerAddress.phone,
    address1: customerAddress.address1,
    address2: customerAddress.address2,
    country: customerAddress.country,
    city: customerAddress.city,
    province: customerAddress.province,
    zip: customerAddress.zip,
    country_code: "IN",
  };

  const discount_codes =
    discounts && discounts.includes(null)
      ? [{}]
      : discounts.map((discount) => {
          return {
            code: discount.code,
            amount: discount.amount,
            type: discount.type,
          };
        });
  return {
    case_id,
    order: {
      oms: true,
      line_items,
      email: customerAddress.email,
      phone: customerAddress.phone,
      billing_address: address,
      shipping_address: address,
      financial_status: "pending",
      discount_codes,
    },
    ...zeroValueOrder,
  };
}

export const getCallProviderComponent = (
  provider = {},
  customer = {},
  phoneType = "phone",
  callDndFlag = false
) => {
  const props = {
    provider,
    customerData: customer,
    phoneType,
    callDndFlag,
  };

  switch (provider?.provider_name) {
    case CALL_PROVIDERS.KNOWLARITY_V1:
      return <KnowlarityIntegration {...props} />;
    case CALL_PROVIDERS.AMEYO:
      return <ExotelAmeyoIntegration {...props} />;
    case CALL_PROVIDERS.AGAMI:
      return <AgamiIntegration {...props} />;
    case CALL_PROVIDERS.UBONA:
      return <UbonaIntegration {...props} />;

    default:
      return <></>;
  }
};
